const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5062').replace(/\/$/, '');
const TOKEN_KEY = 'tripfresh.auth';

export class ApiError extends Error {
  constructor(message, status, details) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.details = details;
  }
}

export function getStoredAuth() {
  try {
    const stored = window.sessionStorage.getItem(TOKEN_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function storeAuth(auth) {
  if (auth) window.sessionStorage.setItem(TOKEN_KEY, JSON.stringify(auth));
  else window.sessionStorage.removeItem(TOKEN_KEY);
}

export async function apiRequest(path, { body, token, signal, method } = {}) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: method || (body === undefined ? 'GET' : 'POST'),
      headers: {
        Accept: 'application/json',
        ...(body === undefined ? {} : { 'Content-Type': 'application/json' }),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body === undefined ? undefined : JSON.stringify(body),
      signal,
    });
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new ApiError(
      `Cannot reach the travel API at ${API_BASE_URL}. Check that the backend is running and CORS is configured.`,
      0,
    );
  }

  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('json')
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const detail = typeof payload === 'string'
      ? payload
      : payload.detail || Object.values(payload.errors || {}).flat().join(' ') ||
        payload.title || payload.message;
    throw new ApiError(detail || `The API returned HTTP ${response.status}.`, response.status, payload);
  }

  return payload;
}
